export default "__VITE_ASSET__71JMXssp__"